import React from 'react';

export const ICON_VARIANT_TYPE = {
  HOUSE: 'house',
  EXCLAMATION: 'exclamation',
  DOWNLOAD: 'download',
  DOCUMENT: 'document',
  TRASH: 'trash',
  READ: 'read',
  FILTER: 'filter',
  FILTER_SECONDARY: 'filter_secondary',
  MEGAPHONE: 'megaphone',
  COMPLETE_DOCUMENT: 'complete_document',
  INCOMPLETE_DOCUMENT: 'incomplete_document',
  WARNING_DOCUMENT: 'warning_document',
  PENDING: 'pending',
  SIGNED: 'signed',
  CLOSE_ACCORDIAN: 'close_accordian',
  OPEN_ACCORDIAN: 'open_accordian',
  DOTS: 'dots',
  DOT: 'dot',
  TICK: 'tick',
  ARROW_DOWN: 'arrow_down',
  ARROW_UP: 'arrow_up',
  PROFILE: 'profile',
  RESEND: 'resend',
  MESSAGE: 'message',
  REMOVE: 'remove',
  REPLACE: 'replace',
  LEAF: 'leaf',
  UPLOAD: 'upload',
  PREVIOUS: 'previous',
  FILE: 'file',
  MODAL_CLOSE: 'modal-close',
  RETURN_CIRCLE: 'return-circle',
  EDIT_PENCIL: 'edit-pencil',
  ADDRESS: 'address',
  SIMPLE_DOTS: 'simple-dot',
  DOWNLOAD_FORM_BUNDLE: 'download-form-bundle',
  DELETE_TRASH: 'delete-trash',
  CLOCK_TIME: 'clock-time',
  COMPLETED_FORM_HISTORY: 'completed-form-history',
  VIEWED: 'viewed',
  TEMPLATE_SUCCESS: 'templateSuccess',
  FORM_LINK: 'formLink',
  DECLINED: 'declined',
  MENU_DOTS_BG: 'MenuDotsBg',
  COPY: 'Copy',
} as const;

export type IconVariant = typeof ICON_VARIANT_TYPE[keyof typeof ICON_VARIANT_TYPE];

interface IconsProps extends React.SVGProps<SVGSVGElement> {
  variant?: IconVariant;
  size?: number;
}

export const Icons = ({ variant, size = 16, ...props }: IconsProps) => {
  const getIcons = () => {
    switch (variant) {
      case ICON_VARIANT_TYPE.HOUSE: {
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
          >
            <path
              d="M5.25027 20.75H4.25027C4.25027 21.3023 4.69799 21.75 5.25027 21.75V20.75ZM6.25027 11C6.25027 10.4477 5.80256 10 5.25027 10C4.69799 10 4.25027 10.4477 4.25027 11H6.25027ZM18.7503 20.75V21.75C19.3026 21.75 19.7503 21.3023 19.7503 20.75H18.7503ZM19.7503 11C19.7503 10.4477 19.3026 10 18.7503 10C18.198 10 17.7503 10.4477 17.7503 11H19.7503ZM6.25027 20.75V11H4.25027V20.75H6.25027ZM5.25027 21.75H18.7503V19.75H5.25027V21.75ZM19.7503 20.75V11H17.7503V20.75H19.7503Z"
              fill="#262626"
            />
            <path
              d="M8.74829 20.75C8.74829 21.3023 9.19601 21.75 9.74829 21.75C10.3006 21.75 10.7483 21.3023 10.7483 20.75H8.74829ZM9.74829 15.5V14.5C9.19601 14.5 8.74829 14.9477 8.74829 15.5H9.74829ZM14.2483 15.5H15.2483C15.2483 14.9477 14.8006 14.5 14.2483 14.5V15.5ZM13.2483 20.75C13.2483 21.3023 13.696 21.75 14.2483 21.75C14.8006 21.75 15.2483 21.3023 15.2483 20.75H13.2483ZM10.7483 20.75V15.5H8.74829V20.75H10.7483ZM9.74829 16.5H14.2483V14.5H9.74829V16.5ZM13.2483 15.5V20.75H15.2483V15.5H13.2483Z"
              fill="#262626"
            />
            <path
              d="M3.11676 10.976C2.68932 11.3258 2.62632 11.9558 2.97604 12.3832C3.32577 12.8107 3.95579 12.8737 4.38324 12.524L3.11676 10.976ZM12 5L12.6332 4.22604C12.2649 3.92465 11.7351 3.92465 11.3668 4.22604L12 5ZM19.6168 12.524C20.0442 12.8737 20.6742 12.8107 21.024 12.3832C21.3737 11.9558 21.3107 11.3258 20.8832 10.976L19.6168 12.524ZM15.7482 5V4C15.1959 4 14.7482 4.44772 14.7482 5H15.7482ZM18.7482 5H19.7482C19.7482 4.44772 19.3005 4 18.7482 4V5ZM18.7482 10.5212L18.1149 11.2952L18.7482 10.5212ZM4.38324 12.524L12.6332 5.77396L11.3668 4.22604L3.11676 10.976L4.38324 12.524ZM11.3668 5.77396L15.1149 8.84064L16.3814 7.29273L12.6332 4.22604L11.3668 5.77396ZM16.7482 8.06668V5H14.7482V8.06668H16.7482ZM15.7482 6H18.7482V4H15.7482V6ZM15.1149 8.84064L18.1149 11.2952L19.3814 9.74727L16.3814 7.29273L15.1149 8.84064ZM18.1149 11.2952L19.6168 12.524L20.8832 10.976L19.3814 9.74727L18.1149 11.2952ZM17.7482 5V10.5212H19.7482V5H17.7482Z"
              fill="#262626"
            />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.EXCLAMATION: {
        return (
          <svg
            width={size}
            height={size}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
          >
            <g clipPath="url(#clip0_8797_141168)">
              <path
                d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
                stroke={props.stroke || '#FF576D'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8 5.33398V8.00065"
                stroke={props.stroke || '#FF576D'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="8" cy="11" r="1" fill={props.stroke || '#FF576D'} />
            </g>
            <defs>
              <clipPath id="clip0_8797_141168">
                <rect width="16" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.WARNING_DOCUMENT: {
        return (
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
          >
            <rect width="40" height="40" rx="20" fill="#FFF2F3" />
            <path
              d="M12 12C12 10.8954 12.8954 10 14 10H22.2459C22.515 10 22.7727 10.1085 22.9609 10.3009L27.715 15.1631C27.8977 15.3499 28 15.6009 28 15.8622V28C28 29.1046 27.1046 30 26 30H14C12.8954 30 12 29.1046 12 28V12Z"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path d="M22 10V14C22 15.1046 22.8954 16 24 16H28" stroke="#FF576D" strokeWidth="2" />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.DOWNLOAD: {
        return (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
          >
            <path
              d="M2.66727 11.3334V12.6667C2.66727 13.0204 2.80774 13.3595 3.05779 13.6095C3.30784 13.8596 3.64698 14.0001 4.0006 14.0001H12.0006C12.3542 14.0001 12.6934 13.8596 12.9434 13.6095C13.1935 13.3595 13.3339 13.0204 13.3339 12.6667V11.3334"
              stroke={props.stroke || '#262626'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4.66727 7.3334L8.0006 10.6667L11.3339 7.3334"
              stroke={props.stroke || '#262626'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8 2.6666V10.6666"
              stroke={props.stroke || '#262626'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.DOCUMENT: {
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
          >
            <g clipPath="url(#clip0_42600_29397)">
              <path
                d="M18.668 4V9.33333C18.668 9.68695 18.8084 10.0261 19.0585 10.2761C19.3085 10.5262 19.6477 10.6667 20.0013 10.6667H25.3346"
                stroke="#515151"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M22.668 28H9.33464C8.62739 28 7.94911 27.719 7.44902 27.219C6.94892 26.7189 6.66797 26.0406 6.66797 25.3333V6.66667C6.66797 5.95942 6.94892 5.28115 7.44902 4.78105C7.94911 4.28095 8.62739 4 9.33464 4H18.668L25.3346 10.6667V25.3333C25.3346 26.0406 25.0537 26.7189 24.5536 27.219C24.0535 27.719 23.3752 28 22.668 28Z"
                stroke="#515151"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_42600_29397">
                <rect width="32" height="32" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.TRASH: {
        return (
          <svg
            width="44"
            height="44"
            viewBox="0 0 44 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
          >
            <rect width="44" height="44" rx="22" fill="white" />
            <path
              d="M14 16.9995H30"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M20 21.0005V27.0005"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M24 21.0005V27.0005"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M15 16.9995L16 28.9995C16 29.5299 16.2107 30.0387 16.5858 30.4137C16.9609 30.7888 17.4696 30.9995 18 30.9995H26C26.5304 30.9995 27.0391 30.7888 27.4142 30.4137C27.7893 30.0387 28 29.5299 28 28.9995L29 16.9995"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M19 17V14C19 13.7348 19.1054 13.4804 19.2929 13.2929C19.4804 13.1054 19.7348 13 20 13H24C24.2652 13 24.5196 13.1054 24.7071 13.2929C24.8946 13.4804 25 13.7348 25 14V17"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.READ: {
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
          >
            <path
              d="M3 19.0002C4.36817 18.2103 5.92017 17.7944 7.5 17.7944C9.07983 17.7944 10.6318 18.2103 12 19.0002C13.3682 18.2103 14.9202 17.7944 16.5 17.7944C18.0798 17.7944 19.6318 18.2103 21 19.0002"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3 5.99972C4.36817 5.2098 5.92017 4.79395 7.5 4.79395C9.07983 4.79395 10.6318 5.2098 12 5.99972C13.3682 5.2098 14.9202 4.79395 16.5 4.79395C18.0798 4.79395 19.6318 5.2098 21 5.99972"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3 6V19"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12 6V19"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21 6V19"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.FILTER: {
        return (
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
          >
            <path
              d="M3.72559 5.82925C3.44271 5.50596 3.6723 5 4.10188 5H19.8981C20.3277 5 20.5573 5.50596 20.2744 5.82925L14 13V18.691C14 18.8804 13.893 19.0535 13.7236 19.1382L10.7236 20.6382C10.3912 20.8044 10 20.5627 10 20.191V13L3.72559 5.82925Z"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.FILTER_SECONDARY: {
        return (
          <svg
            width="20"
            height="18"
            viewBox="0 0 20 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
          >
            <path
              d="M1.72559 1.82925C1.44271 1.50596 1.6723 1 2.10188 1H17.8981C18.3277 1 18.5573 1.50596 18.2744 1.82925L12 9V14.691C12 14.8804 11.893 15.0535 11.7236 15.1382L8.72361 16.6382C8.39116 16.8044 8 16.5627 8 16.191V9L1.72559 1.82925Z"
              stroke="#303030"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.MEGAPHONE: {
        return (
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
          >
            <path
              d="M23.1363 12.5006C22.3556 14.339 18.7447 16.8098 12.9496 18.289C12.1469 18.4938 11.6282 19.2871 11.8004 20.0974L12.0084 21.0755C12.1806 21.8859 12.9771 22.3995 13.7937 22.2602C19.6895 21.2544 23.9931 22.0429 25.454 23.4049C25.858 23.7815 26.4097 24.1485 26.9499 24.0337C27.4901 23.9188 27.835 23.3878 27.7201 22.8476L25.4331 12.088C25.3183 11.5478 24.7873 11.2029 24.247 11.3178C23.7068 11.4326 23.3521 11.9922 23.1363 12.5006Z"
              stroke="#515151"
              strokeWidth="2"
              strokeLinejoin="round"
            />
            <path
              d="M15.3586 22.4082L18.3071 27.705C18.5207 28.0886 18.9594 28.2881 19.3888 28.1968L20.2764 28.0081C20.9345 27.8682 21.2695 27.1314 20.9423 26.5436L18.2931 21.7845"
              stroke="#515151"
              strokeWidth="2"
            />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.COMPLETE_DOCUMENT: {
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
          >
            <path
              d="M18.668 4V9.33333C18.668 9.68695 18.8084 10.0261 19.0585 10.2761C19.3085 10.5262 19.6477 10.6667 20.0013 10.6667H25.3346"
              stroke="#00B152"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M22.668 28H9.33464C8.62739 28 7.94911 27.719 7.44902 27.219C6.94892 26.7189 6.66797 26.0406 6.66797 25.3333V6.66667C6.66797 5.95942 6.94892 5.28115 7.44902 4.78105C7.94911 4.28095 8.62739 4 9.33464 4H18.668L25.3346 10.6667V25.3333C25.3346 26.0406 25.0537 26.7189 24.5536 27.219C24.0535 27.719 23.3752 28 22.668 28Z"
              stroke="#00B152"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13 18L15 20L20 15"
              stroke="#00B152"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.INCOMPLETE_DOCUMENT: {
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
          >
            <path
              d="M18.668 4V9.33333C18.668 9.68695 18.8084 10.0261 19.0585 10.2761C19.3085 10.5262 19.6477 10.6667 20.0013 10.6667H25.3346"
              stroke={props.stroke || '#515151'}
              strokeWidth={props.strokeWidth || '2'}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M22.668 28H9.33464C8.62739 28 7.94911 27.719 7.44902 27.219C6.94892 26.7189 6.66797 26.0406 6.66797 25.3333V6.66667C6.66797 5.95942 6.94892 5.28115 7.44902 4.78105C7.94911 4.28095 8.62739 4 9.33464 4H18.668L25.3346 10.6667V25.3333C25.3346 26.0406 25.0537 26.7189 24.5536 27.219C24.0535 27.719 23.3752 28 22.668 28Z"
              stroke={props.stroke || '#515151'}
              strokeWidth={props.strokeWidth || '2'}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.SIGNED: {
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
          >
            <circle
              cx="10.0002"
              cy="10.0002"
              r="7.88889"
              fill="white"
              stroke="#00B152"
              strokeWidth="2"
            />
            <path
              d="M6.66699 10.5556L8.88921 12.7778L13.8892 7.77783"
              stroke="#00B152"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.PENDING: {
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
          >
            <path
              d="M5.14062 3.19434V2.19434C4.58834 2.19434 4.14062 2.64205 4.14062 3.19434H5.14062ZM5.14062 16.8054H4.14062C4.14062 17.3577 4.58834 17.8054 5.14062 17.8054V16.8054ZM14.8628 16.8054V17.8054C15.4151 17.8054 15.8628 17.3577 15.8628 16.8054H14.8628ZM14.8628 3.19434H15.8628C15.8628 2.64205 15.4151 2.19434 14.8628 2.19434V3.19434ZM4.14062 3.19434C4.14062 5.87961 4.96593 7.32225 5.8397 8.34166C6.04187 8.57752 6.24405 8.78798 6.40849 8.96156C6.58152 9.14421 6.71022 9.28343 6.81406 9.41611C7.00157 9.65571 7.05729 9.80872 7.05729 9.99989H9.05729C9.05729 9.21884 8.74843 8.64269 8.38907 8.1835C8.21947 7.96678 8.02915 7.76421 7.86039 7.58607C7.68304 7.39886 7.52063 7.22956 7.35821 7.04007C6.77366 6.35809 6.14062 5.37018 6.14062 3.19434H4.14062ZM7.05729 9.99989C7.05729 10.1911 7.00157 10.3441 6.81406 10.5837C6.71022 10.7163 6.58152 10.8556 6.40849 11.0382C6.24405 11.2118 6.04187 11.4223 5.8397 11.6581C4.96593 12.6775 4.14062 14.1202 4.14062 16.8054H6.14062C6.14062 14.6296 6.77366 13.6417 7.35821 12.9597C7.52063 12.7702 7.68304 12.6009 7.86039 12.4137C8.02915 12.2356 8.21947 12.033 8.38907 11.8163C8.74843 11.3571 9.05729 10.7809 9.05729 9.99989H7.05729ZM5.14062 17.8054H14.8628V15.8054H5.14062V17.8054ZM15.8628 16.8054C15.8628 14.1202 15.0375 12.6775 14.1638 11.6581C13.9616 11.4223 13.7594 11.2118 13.595 11.0382C13.4219 10.8556 13.2933 10.7163 13.1894 10.5837C13.0019 10.3441 12.9462 10.1911 12.9462 9.99989H10.9462C10.9462 10.7809 11.255 11.3571 11.6144 11.8163C11.784 12.033 11.9743 12.2356 12.1431 12.4137C12.3204 12.6009 12.4828 12.7702 12.6453 12.9597C13.2298 13.6417 13.8628 14.6296 13.8628 16.8054H15.8628ZM12.9462 9.99989C12.9462 9.80872 13.0019 9.65571 13.1894 9.41611C13.2933 9.28343 13.4219 9.14421 13.595 8.96156C13.7594 8.78798 13.9616 8.57752 14.1638 8.34166C15.0375 7.32225 15.8628 5.87961 15.8628 3.19434H13.8628C13.8628 5.37018 13.2298 6.35809 12.6453 7.04007C12.4828 7.22956 12.3204 7.39886 12.1431 7.58607C11.9743 7.76421 11.784 7.96678 11.6144 8.1835C11.255 8.64269 10.9462 9.21884 10.9462 9.99989H12.9462ZM14.8628 2.19434H5.14062V4.19434H14.8628V2.19434Z"
              fill="#AAABAB"
            />
            <path
              d="M4.16797 3.19434H15.8346"
              stroke="#AAABAB"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4.16797 16.8057H15.8346"
              stroke="#AAABAB"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9.99913 11.9443C9.51302 11.9443 8.05469 13.4027 8.05469 14.861H11.9436C11.9436 13.4027 10.4852 11.9443 9.99913 11.9443Z"
              fill="#AAABAB"
            />
            <path
              d="M9.99957 8.05566C9.75651 8.05566 9.02734 7.56955 9.02734 7.08344H10.9718C10.9718 7.56955 10.2426 8.05566 9.99957 8.05566Z"
              fill="#AAABAB"
            />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.OPEN_ACCORDIAN: {
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
          >
            <circle cx="16" cy="16" r="16" fill="#F4F5F6" />
            <path d="M11 16H21" stroke="#262626" strokeWidth="2" strokeLinecap="round" />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.CLOSE_ACCORDIAN: {
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
          >
            <circle cx="16" cy="16" r="16" fill="#F4F5F6" />
            <path
              d="M16 11V21"
              stroke="#262626"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path d="M11 16H21" stroke="#262626" strokeWidth="2" strokeLinecap="round" />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.DOTS: {
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
          >
            <rect width="32" height="32" rx="16" fill="#E8E9EA" />
            <circle cx="9" cy="16" r="2" fill="#262626" />
            <circle cx="16" cy="16" r="2" fill="#262626" />
            <circle cx="23" cy="16" r="2" fill="#262626" />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.DOT: {
        return (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
          >
            <circle cx="8" cy="8" r="6" fill="#D6D6D7" />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.TICK: {
        return (
          <svg
            width="13"
            height="10"
            viewBox="0 0 13 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
          >
            <path
              d="M1.33203 5.0013L4.66536 8.33463L11.332 1.66797"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.ARROW_UP: {
        return (
          <svg
            width="12"
            height="7"
            viewBox="0 0 12 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
          >
            <path
              d="M1.5 6L6 1.5L10.5 6"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.ARROW_DOWN: {
        return (
          <svg
            width="12"
            height="7"
            viewBox="0 0 12 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
          >
            <path
              d="M1.5 1L6 5.5L10.5 1"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.PROFILE: {
        return (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
          >
            <path
              d="M11 5C11 6.65685 9.65685 8 8 8C6.34315 8 5 6.65685 5 5C5 3.34315 6.34315 2 8 2C9.65685 2 11 3.34315 11 5Z"
              stroke="#FF576D"
              strokeWidth="2"
            />
            <path
              d="M3 13.9985C3.5 12 5 11 7 11L9 11C11 11 12.5 12 13 13.9985"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.RESEND: {
        return (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.36654 10C2.87235 11.3848 3.87026 12.5348 5.16987 13.2308C6.46948 13.9267 7.97981 14.1198 9.41272 13.7733C10.8456 13.4267 12.1008 12.5648 12.9388 11.3519C13.7767 10.139 14.1388 8.66003 13.956 7.1972C13.7731 5.73436 13.0581 4.39005 11.9474 3.42074C10.8366 2.45142 9.40791 1.92496 7.93379 1.9418C6.45967 1.95864 5.04334 2.51759 3.95503 3.51202C3.20615 4.1963 2.64865 5.05381 2.32507 6M2.0332 13.3334V10H5.36654"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.MESSAGE: {
        return (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
          >
            <path
              d="M2.94988 11.0047L3.86995 11.3964L4.06774 10.9319L3.81138 10.4969L2.94988 11.0047ZM1.85385 13.5788L0.933775 13.1871H0.933775L1.85385 13.5788ZM2.49384 14.2412L2.85376 15.1742L2.85377 15.1742L2.49384 14.2412ZM5.20541 13.1952L5.68761 12.3191L5.2798 12.0946L4.84549 12.2622L5.20541 13.1952ZM12.9847 8.00014C12.9847 10.7207 10.7793 12.9261 8.05874 12.9261V14.9261C11.8838 14.9261 14.9847 11.8252 14.9847 8.00014H12.9847ZM8.05874 3.07422C10.7793 3.07422 12.9847 5.27963 12.9847 8.00014H14.9847C14.9847 4.17506 11.8838 1.07422 8.05874 1.07422V3.07422ZM3.13281 8.00014C3.13281 5.27963 5.33822 3.07422 8.05874 3.07422V1.07422C4.23365 1.07422 1.13281 4.17506 1.13281 8.00014H3.13281ZM3.81138 10.4969C3.38036 9.76561 3.13281 8.91331 3.13281 8.00014H1.13281C1.13281 9.28013 1.48097 10.4819 2.08837 11.5124L3.81138 10.4969ZM2.77392 13.9706L3.86995 11.3964L2.0298 10.6129L0.933775 13.1871L2.77392 13.9706ZM2.13393 13.3082C2.54622 13.1492 2.94704 13.564 2.77392 13.9706L0.933775 13.1871C0.414406 14.4069 1.61686 15.6514 2.85376 15.1742L2.13393 13.3082ZM4.84549 12.2622L2.13392 13.3082L2.85377 15.1742L5.56533 14.1281L4.84549 12.2622ZM8.05874 12.9261C7.19716 12.9261 6.39005 12.7057 5.68761 12.3191L4.72321 14.0712C5.71358 14.6163 6.85149 14.9261 8.05874 14.9261V12.9261Z"
              fill="#FF576D"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.19097 7.99978C6.19097 8.61343 5.69351 9.11089 5.07986 9.11089C4.46621 9.11089 3.96875 8.61343 3.96875 7.99978C3.96875 7.38613 4.46621 6.88867 5.07986 6.88867C5.69351 6.88867 6.19097 7.38613 6.19097 7.99978ZM9.15191 7.99978C9.15191 8.61343 8.65445 9.11089 8.0408 9.11089C7.42715 9.11089 6.92969 8.61343 6.92969 7.99978C6.92969 7.38613 7.42715 6.88867 8.0408 6.88867C8.65445 6.88867 9.15191 7.38613 9.15191 7.99978ZM11.0056 9.11089C11.6193 9.11089 12.1168 8.61343 12.1168 7.99978C12.1168 7.38613 11.6193 6.88867 11.0056 6.88867C10.392 6.88867 9.89453 7.38613 9.89453 7.99978C9.89453 8.61343 10.392 9.11089 11.0056 9.11089Z"
              fill="#FF576D"
            />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.REMOVE: {
        return (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
          >
            <path
              d="M2.66797 4.6665H13.3346"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6.66797 7.3335V11.3335"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9.33203 7.3335V11.3335"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3.33203 4.6665L3.9987 12.6665C3.9987 13.0201 4.13917 13.3593 4.38922 13.6093C4.63927 13.8594 4.97841 13.9998 5.33203 13.9998H10.6654C11.019 13.9998 11.3581 13.8594 11.6082 13.6093C11.8582 13.3593 11.9987 13.0201 11.9987 12.6665L12.6654 4.6665"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6 4.66667V2.66667C6 2.48986 6.07024 2.32029 6.19526 2.19526C6.32029 2.07024 6.48986 2 6.66667 2H9.33333C9.51014 2 9.67971 2.07024 9.80474 2.19526C9.92976 2.32029 10 2.48986 10 2.66667V4.66667"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.REPLACE: {
        return (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.59961 13.5999V10.3999H4.79961"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14.4004 2.4001V5.6001H11.2004"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2.24733 10.8057C2.85487 12.0513 3.85036 13.0661 5.08412 13.6975C6.31789 14.3288 7.72325 14.5426 9.08895 14.3067C10.4546 14.0708 11.7069 13.398 12.6574 12.3893C13.6078 11.3807 14.2052 10.0908 14.3597 8.7135"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13.7527 5.19433C13.1451 3.94867 12.1496 2.93389 10.9159 2.30254C9.68211 1.67119 8.27675 1.45739 6.91105 1.69329C5.54535 1.92919 4.29313 2.60203 3.34264 3.61066C2.39216 4.6193 1.79476 5.90922 1.64028 7.2865"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.LEAF: {
        return (
          <svg
            viewBox="64 64 896 896"
            focusable="false"
            data-icon="file"
            width="1em"
            height="1em"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z"></path>
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.UPLOAD: {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="44"
            height="44"
            viewBox="0 0 44 44"
            fill="none"
            {...props}
          >
            <g clipPath="url(#clip0_12270_218583)">
              <path
                d="M12.835 33.0031C10.5475 33.0031 8.35367 32.1339 6.73616 30.5867C5.11866 29.0396 4.20996 26.9412 4.20996 24.7531C4.20996 22.5651 5.11866 20.4667 6.73616 18.9195C8.35367 17.3723 10.5475 16.5031 12.835 16.5031V16.5031C13.3752 14.0963 14.9557 11.9812 17.2287 10.6231C18.3542 9.95065 19.6158 9.4843 20.9415 9.25066C22.2673 9.01703 23.6312 9.0207 24.9553 9.26146C26.2795 9.50222 27.538 9.97535 28.659 10.6538C29.78 11.3323 30.7415 12.2029 31.4887 13.2158C32.2359 14.2288 32.754 15.3642 33.0136 16.5574C33.2732 17.7505 33.2691 18.978 33.0016 20.1698H34.835C36.5368 20.1698 38.1689 20.8458 39.3722 22.0492C40.5756 23.2525 41.2516 24.8846 41.2516 26.5865C41.2516 28.2883 40.5756 29.9204 39.3722 31.1237C38.1689 32.3271 36.5368 33.0031 34.835 33.0031H33.0016"
                stroke="#AAABAB"
                strokeWidth="2.75"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M16.5 27.5L22 22L27.5 27.5"
                stroke="#AAABAB"
                strokeWidth="2.75"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M22 22V38.5"
                stroke="#AAABAB"
                strokeWidth="2.75"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_12270_218583">
                <rect width="44" height="44" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.PREVIOUS: {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M15 21L6 12L15 3"
              stroke="#515151"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.FILE: {
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
          >
            <rect width="32" height="32" rx="16" fill="#F4F5F6" />
            <path
              d="M9.33301 9.66601C9.33301 8.56145 10.2284 7.66602 11.333 7.66602H17.8011C18.0702 7.66602 18.328 7.77448 18.5161 7.9669L22.3813 11.92C22.564 12.1068 22.6663 12.3578 22.6663 12.6191V22.3327C22.6663 23.4373 21.7709 24.3327 20.6663 24.3327H11.333C10.2284 24.3327 9.33301 23.4373 9.33301 22.3327V9.66601Z"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M17.667 7.66602V10.666C17.667 11.7706 18.5624 12.666 19.667 12.666H22.667"
              stroke="#515151"
              strokeWidth="2"
            />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.MODAL_CLOSE: {
        return (
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
          >
            <g clipPath="url(#clip0_75453_70113)">
              <path
                d="M28 12L12 28"
                stroke="#515151"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12 12L28 28"
                stroke="#515151"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_75453_70113">
                <rect width="32" height="32" fill="white" transform="translate(4 4)" />
              </clipPath>
            </defs>
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.RETURN_CIRCLE: {
        return (
          <svg
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
          >
            <circle opacity="0.1" cx="28" cy="28" r="28" fill="#252D44" />
            <path
              d="M19.6991 28.7607C19.5476 30.5277 19.9519 32.2979 20.8553 33.824C21.7588 35.35 23.1164 36.5558 24.7384 37.2729C26.3605 37.9899 28.166 38.1824 29.9027 37.8235C31.6395 37.4646 33.2208 36.5721 34.4257 35.2708C35.6306 33.9696 36.399 32.3244 36.6235 30.5652C36.848 28.806 36.5175 27.0206 35.678 25.4584C34.8385 23.8962 33.532 22.6352 31.9411 21.8516C28.9538 20.3803 24.3109 20.9759 24.3109 20.9759M24.3109 20.9759L28.9538 16.333M24.3109 20.9759L28.9538 25.4584"
              stroke="#252D44"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.EDIT_PENCIL: {
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
          >
            <path
              d="M4 20.0013H8L18.5 9.50128C19.0304 8.97085 19.3284 8.25142 19.3284 7.50128C19.3284 6.75113 19.0304 6.03171 18.5 5.50128C17.9696 4.97085 17.2501 4.67285 16.5 4.67285C15.7499 4.67285 15.0304 4.97085 14.5 5.50128L4 16.0013V20.0013Z"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13.5 6.50098L17.5 10.501"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.ADDRESS: {
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="16" cy="16" r="16" fill="#F4F5F6" />
            <ellipse cx="16" cy="15.167" rx="2.5" ry="2.5" stroke="#515151" strokeWidth="2" />
            <path
              d="M22.6663 15.1667C22.6663 18.8846 18.9802 22.3721 17.0899 23.9162C16.4484 24.4401 15.5509 24.4401 14.9095 23.9162C13.0191 22.3721 9.33301 18.8846 9.33301 15.1667C9.33301 11.4848 12.3178 8.5 15.9997 8.5C19.6816 8.5 22.6663 11.4848 22.6663 15.1667Z"
              stroke="#515151"
              strokeWidth="2"
            />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.SIMPLE_DOTS: {
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="5" cy="12" r="2" fill="#515151" />
            <circle cx="12" cy="12" r="2" fill="#515151" />
            <circle cx="19" cy="12" r="2" fill="#515151" />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.DOWNLOAD_FORM_BUNDLE: {
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="16" cy="16" r="16" fill="#F4F5F6" />
            <path
              d="M10.668 19.333V20.6663C10.668 21.02 10.8084 21.3591 11.0585 21.6092C11.3085 21.8592 11.6477 21.9997 12.0013 21.9997H20.0013C20.3549 21.9997 20.6941 21.8592 20.9441 21.6092C21.1942 21.3591 21.3346 21.02 21.3346 20.6663V19.333"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12.668 15.333L16.0013 18.6663L19.3346 15.333"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M16 10.667V18.667"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.DELETE_TRASH: {
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_58693_77250)">
              <path
                d="M4 7H20"
                stroke="#EC455E"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10 11V17"
                stroke="#EC455E"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M14 11V17"
                stroke="#EC455E"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M5 7L6 19C6 19.5304 6.21071 20.0391 6.58579 20.4142C6.96086 20.7893 7.46957 21 8 21H16C16.5304 21 17.0391 20.7893 17.4142 20.4142C17.7893 20.0391 18 19.5304 18 19L19 7"
                stroke="#EC455E"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9 7V4C9 3.73478 9.10536 3.48043 9.29289 3.29289C9.48043 3.10536 9.73478 3 10 3H14C14.2652 3 14.5196 3.10536 14.7071 3.29289C14.8946 3.48043 15 3.73478 15 4V7"
                stroke="#EC455E"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_58693_77250">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.CLOCK_TIME: {
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="16" cy="16" r="16" fill="#F4F5F6" />
            <path
              d="M23.75 16C23.75 11.7198 20.2802 8.25 16 8.25C11.7198 8.25 8.25 11.7198 8.25 16C8.25 20.2802 11.7198 23.75 16 23.75C20.2802 23.75 23.75 20.2802 23.75 16Z"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M16 12.5V16L18.5 18"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.COMPLETED_FORM_HISTORY: {
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle opacity="0.08" cx="16" cy="16" r="16" fill="#00B152" />
            <path
              d="M10.668 16.8878L14.2235 20.4434L22.2235 12.4434"
              stroke="#00B152"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.VIEWED: {
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22 12C22 12.5833 19 19 12 19C5 19 2 12.5833 2 12C2 11.4167 5 5 12 5C19 5 22 11.4167 22 12Z"
              stroke="#AAABAB"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <circle cx="12" cy="12" r="3" stroke="#AAABAB" strokeWidth="2" />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.TEMPLATE_SUCCESS: {
        return (
          <svg
            width="56"
            height="57"
            viewBox="0 0 56 57"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0 56.92H56V0.92H0V56.92Z" fill="#252D44" />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.FORM_LINK: {
        return (
          <svg
            width="33"
            height="32"
            viewBox="0 0 33 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_75367_20933)">
              <path
                d="M13.8335 18.6668C14.268 19.1103 14.7866 19.4626 15.359 19.7031C15.9314 19.9436 16.546 20.0675 17.1668 20.0675C17.7877 20.0675 18.4023 19.9436 18.9747 19.7031C19.547 19.4626 20.0657 19.1103 20.5002 18.6668L25.8335 13.3335C26.7176 12.4495 27.2142 11.2504 27.2142 10.0002C27.2142 8.74994 26.7176 7.5509 25.8335 6.66684C24.9494 5.78279 23.7504 5.28613 22.5002 5.28613C21.2499 5.28613 20.0509 5.78279 19.1668 6.66684L18.5002 7.33351"
                stroke="#D6D6D7"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M19.1664 13.3333C18.7319 12.8898 18.2132 12.5375 17.6409 12.297C17.0685 12.0565 16.4539 11.9326 15.833 11.9326C15.2122 11.9326 14.5976 12.0565 14.0252 12.297C13.4528 12.5375 12.9342 12.8898 12.4997 13.3333L7.16636 18.6666C6.2823 19.5507 5.78564 20.7497 5.78564 22C5.78564 23.2502 6.2823 24.4492 7.16636 25.3333C8.05041 26.2174 9.24945 26.714 10.4997 26.714C11.7499 26.714 12.949 26.2174 13.833 25.3333L14.4997 24.6666"
                stroke="#D6D6D7"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M21.8335 27.9997V25.333"
                stroke="#D6D6D7"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M25.8335 21.333H28.5002"
                stroke="#D6D6D7"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M4.5 10.667H7.16667"
                stroke="#D6D6D7"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M11.1665 4V6.66667"
                stroke="#D6D6D7"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_75367_20933">
                <rect width="32" height="32" fill="white" transform="translate(0.5)" />
              </clipPath>
            </defs>
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.DECLINED: {
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="9" stroke="#EC455E" strokeWidth="2" />
            <path
              d="M9 15L15 9"
              stroke="#EC455E"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M15 15L9 9"
              stroke="#EC455E"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.MENU_DOTS_BG: {
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="32" height="32" rx="16" fill="#E8E9EA" />
            <circle cx="9" cy="16" r="2" fill="#515151" />
            <circle cx="16" cy="16" r="2" fill="#515151" />
            <circle cx="23" cy="16" r="2" fill="#515151" />
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.COPY: {
        return (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.5 1H7.5C6.67157 1 6 1.67157 6 2.5V9.5C6 10.3284 6.67157 11 7.5 11H12.5C13.3284 11 14 10.3284 14 9.5V2.5C14 1.67157 13.3284 1 12.5 1Z"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6 5H3.5C2.67157 5 2 5.67157 2 6.5V13.5C2 14.3284 2.67157 15 3.5 15H8.5C9.32843 15 10 14.3284 10 13.5V11"
              stroke="#FF576D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      default: {
        return <></>;
      }
    }
  };

  return getIcons();
};
